import Icon from '../components/Icon.vue'

Icon.register({
  'user-plus': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M624 208H560V144C560 135.2 552.8 128 544 128H512C503.2 128 496 135.2 496 144V208H432C423.2 208 416 215.2 416 224V256C416 264.8 423.2 272 432 272H496V336C496 344.8 503.2 352 512 352H544C552.8 352 560 344.8 560 336V272H624C632.8 272 640 264.8 640 256V224C640 215.2 632.8 208 624 208zM224 256C294.7 256 352 198.7 352 128S294.7 0 224 0 96 57.3 96 128 153.3 256 224 256zM313.6 288H296.9C274.7 298.2 250 304 224 304S173.4 298.2 151.1 288H134.4C60.2 288 0 348.2 0 422.4V464C0 490.5 21.5 512 48 512H400C426.5 512 448 490.5 448 464V422.4C448 348.2 387.8 288 313.6 288z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/user-plus.js
// module id = pjPt
// module chunks = 144